export function scrollToElementAndHighlight(element: Element | null): void {
    if (element) {
        element.scrollIntoView({block: 'center'});
        element.classList.add('current-hl');
        setTimeout(() => {
            element.classList.remove('current-hl');
        }, 1000);
    }
}
